import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';

import { queryClient } from '../core/network/query-client';
import { ROUTES } from '../core/constants/routes';
import { DrawsProvider } from '../global/contexts/lottery/draws';
import { TicketsProvider } from '../global/contexts/lottery/tickets';
import Footer from '../features/footer/footer';
import Header from '../features/headers/header';

import HomePage from '../pages/public/home';
import StorePage from '../pages/public/store';
import TicketsPage from '../pages/public/tickets';
import ChangelogPage from '../pages/public/changelog';

// TSS vite/01 — app shell. Wires providers, router, layout chrome.
// TSS vite/03 §"Provider composition order" — Router → QueryClient →
// cross-app providers. There is no AuthProvider layer: every surface of this
// demo is public and no backend is involved. The auth stack the template ships
// (global/contexts/auth, core/network) is left untouched on disk so a real
// deployment can slot it back in at the documented position.
// See docs/decisions/0001-simulated-lottery-domain.md.

export default function App() {
    return (
        <BrowserRouter>
            <QueryClientProvider client={queryClient}>
                <DrawsProvider>
                    <TicketsProvider>
                        <div className="app-shell">
                            <Header />
                            <AppRouter />
                            <Footer />
                        </div>
                    </TicketsProvider>
                </DrawsProvider>
                <Toaster
                    position="top-right"
                    toastOptions={{
                        style: {
                            background: '#0a1e44',
                            color: '#e9f0ff',
                            border: '1px solid rgba(255,255,255,0.12)',
                            fontSize: '14px',
                        },
                    }}
                />
            </QueryClientProvider>
        </BrowserRouter>
    );
}

function AppRouter() {
    return (
        <main className="app-shell__main">
            <Routes>
                {/* Public surfaces — unwrapped per TSS vite/01 §"Route registration". */}
                <Route path={ROUTES.HOME} element={<HomePage />} />
                <Route path={ROUTES.STORE} element={<StorePage />} />
                <Route path={ROUTES.TICKETS} element={<TicketsPage />} />
                <Route path={ROUTES.CHANGELOG} element={<ChangelogPage />} />

                <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
            </Routes>
        </main>
    );
}
